import React from "react";
import { Field, reduxForm } from "redux-form";
import { Stack, PrimaryButton } from "@fluentui/react";
import * as FormHepler from "./formHelper";
import * as Validations from "./validation";
import { connect } from "react-redux";

const StockClientUpdateForm = (props) => {
  const { handleSubmit, clients } = props;

  return (
    <form onSubmit={handleSubmit} noValidate className="admin-forms">
      <Stack tokens={{ childrenGap: 15 }}>
        <Field
          name="clientId"
          label="Client"
          required={true}
          isSearchable={true}
          width={200}
          placeholder="Select Client"
          component={FormHepler.RenderSearchDropDown}
          validate={Validations.required}
          options={clients.map((client) => ({
            value: client.id,
            label: client.clientName,
          }))}
        />
        <div style={{ height: "200px" }}></div>
        <div className="form-actions">
          <PrimaryButton type="submit">Update Client</PrimaryButton>
        </div>
      </Stack>
    </form>
  );
};

const StockClientUpdateFormMapped = reduxForm({
  form: "stockClientUpdateForm",
  enableReinitialize: true,
})(StockClientUpdateForm);

const mapStateToProps = ({ meta }) => ({
  clients: meta.clients,
});

export default connect(mapStateToProps)(StockClientUpdateFormMapped);
